"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Node {
    constructor() {
        this.children = new Set();
        this.neighbors = new Map();
        this.dirty = true;
        this.id = `${Node.idCounter++}`;
    }
    get location() {
        return this.sampleChild ? this.sampleChild.location : null;
    }
    get travelCost() {
        if (this.dirty) {
            // TODO: Consider using the highest travelCost instead of an average
            //       To improve what isObstacle means
            this._travelCost = average(this.children, 'travelCost');
        }
        return this._travelCost;
    }
    get isObstacle() {
        return this.travelCost === 1;
    }
    addChild(child) {
        this.dirty = true;
        this.children.add(child);
        this.sampleChild = child;
        // (child as any).color = 'brown';
        // (child as any).content = this.id;
    }
    hasChild(child) {
        if (this.children.has(child))
            return true;
        for (const entry of this.children) {
            if (entry.isNeighbor(child)) {
                this.addChild(child);
                return true;
            }
        }
        return false;
    }
    setNeighbor(node, relation) {
        const current = this.neighbors.get(node);
        if (!current || current.cost > relation.cost)
            this.neighbors.set(node, relation);
    }
    removeNeighbor(node) {
        this.neighbors.delete(node);
    }
    getNeighbors() {
        return this.neighbors;
    }
    getRelation(neighbor) {
        if (!this.isNeighbor(neighbor))
            throw new Error('Argument should be a neighbor');
        return this.neighbors.get(neighbor);
    }
    isNeighbor(node) {
        return this.neighbors.has(node);
    }
    getCostTo(neighbor) {
        return this.getRelation(neighbor).cost;
    }
    estimateDistanceTo(node) {
        return this.sampleChild.estimateDistanceTo(node.sampleChild);
    }
}
Node.idCounter = 0;
exports.Node = Node;
class TemporalNode extends Node {
    reconnect() {
        for (const [neighbor, relation] of this.getNeighbors())
            neighbor.setNeighbor(this, relation);
        return this;
    }
    disconnect() {
        for (const [neighbor, relation] of this.getNeighbors())
            neighbor.removeNeighbor(this);
    }
}
exports.TemporalNode = TemporalNode;
function average(list, property) {
    let sum = 0;
    for (const entry of list)
        sum += entry[property];
    return sum / list.size;
}



//////////////////
// WEBPACK FOOTER
// ./src/pathfinding/node.ts
// module id = 11
// module chunks = 0